import * as Yup from "yup";

export const LoginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email(
      "Email is invalid. Please enter a valid email address (e.g. name@domain.com)"
    )
    .required("Email is invalid. Please enter a valid email address"),
  password: Yup.string().required("Required"),
});

export const ForgotPasswordValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email(
      "Email is invalid. Please enter a valid email address (e.g. name@domain.com)"
    )
    .required("Email is invalid. Please enter a valid email address"),
});

export const UserValidationSchema = Yup.object().shape({
  firstname: Yup.string().required("First name is required"),
  lastname: Yup.string().required("Last name is required"),
  email: Yup.string()
    .email(
      "Email is invalid. Please enter a valid email address (e.g. name@domain.com)"
    )
    .required("Email is required"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(
      /^\d{10}$/,
      "Phone number is invalid. Please enter a valid phone number (e.g. 1234567890)"
    ),

  role: Yup.string().required("Role is required"),
});
